import { Image } from '@toasttab/shared/src/interfaces/ContentfulInterface.d'
import { ContentfulImageAPI } from '../contentfulUtils'

const buildImageResolution = (
  image: Image,
  widths = [320, 640, 768, 1024, 1280, 1536, 1920],
  borderRadius = {
    label: 'Large'
  }
) => {
  let desktop = []
  let tablet = []
  let mobile = []

  if (!image) {
    return
  }

  if (image.desktop) {
    let query = ''
    let imageUrl = image.desktop.file.url
    if (!imageUrl.includes('http')) {
      imageUrl = `https:${imageUrl}`
    }
    let srcsetAvif = imageUrl
    if (image.desktop.file.contentType === 'image/png') {
      query = ContentfulImageAPI.transformImageAvif()
      srcsetAvif = ContentfulImageAPI.transformImageAvifSrcset({
        url: image.desktop.file.url,
        widths: widths
      })
    }

    desktop.push({
      title: image.desktop.title,
      url: imageUrl,
      extension: image.desktop.file.contentType,
      optimizedImages: {
        src: '',
        srcset: imageUrl,
        srcsetMaxWidth: '',
        srcsetAvif,
        placeholderBox: '',
        placeholderImage: '',
        maxSrcsetWidth: '',
        srcAvif: imageUrl + query
      }
    })
  }
  if (image.tablet) {
    let query = ''
    let imageUrl = image.tablet.file.url
    let srcsetAvif = imageUrl
    if (image.tablet.file.contentType === 'image/png') {
      query = ContentfulImageAPI.transformImageAvif()
      srcsetAvif = ContentfulImageAPI.transformImageAvifSrcset({
        url: image.tablet.file.url,
        widths: widths
      })
    }
    tablet.push({
      title: image.tablet.title,
      url: image.tablet.file.url,
      extension: image.tablet.file.contentType,
      optimizedImages: {
        src: '',
        srcset: imageUrl,
        srcsetMaxWidth: '',
        srcsetAvif,
        placeholderBox: '',
        placeholderImage: '',
        maxSrcsetWidth: '',
        srcAvif: imageUrl + query
      }
    })
  }
  if (image.mobile) {
    let query = ''
    let imageUrl = image.mobile.file.url
    let srcsetAvif = imageUrl
    if (image.mobile.file.contentType === 'image/png') {
      query = ContentfulImageAPI.transformImageAvif()
      srcsetAvif = ContentfulImageAPI.transformImageAvifSrcset({
        url: image.mobile.file.url,
        widths: widths
      })
    }
    mobile.push({
      title: image.mobile.title,
      url: imageUrl,
      extension: image.mobile.file.contentType,
      optimizedImages: {
        src: '',
        srcset: imageUrl,
        srcsetMaxWidth: '',
        srcsetAvif,
        placeholderBox: '',
        placeholderImage: '',
        maxSrcsetWidth: '',
        srcAvif: imageUrl + query
      }
    })
  }

  return [
    {
      borderRadius: borderRadius,
      desktop: desktop,
      mobile: mobile,
      tablet: tablet,
      title: image.title,
      typeHandle: 'images'
    }
  ]
}

export default buildImageResolution
